import { Directive, Input, TemplateRef, ViewContainerRef } from "@angular/core";
import { AuthRealmService } from "../services/keycloak/auth-realm.service";

@Directive({
  selector: "[appHasRole]",
  standalone: true,
})
export class HasRoleDirective {
  /**
   * Initializes the directive with dependencies for template rendering and role validation.
   * @param templateRef - Reference to the template to be conditionally rendered.
   * @param viewContainer - Container for embedding or clearing the template.
   * @param authRealmService - Service to check user roles.
   */
  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private authRealmService: AuthRealmService
  ) {}

  /**
   * Input property to specify the role(s) required to render the template.
   * If the authenticated user has the specified role(s), the template is rendered;
   * otherwise, it is removed from the view.
   * @param role - A string representing a single role or an array of strings for multiple roles.
   */
  @Input() set appHasRole(role: string | string[]) {
    const hasRole = Array.isArray(role)
      ? this.authRealmService.hasAnyRole(role)
      : this.authRealmService.hasRole(role);

    if (hasRole) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    } else {
      this.viewContainer.clear();
    }
  }
}
